<gaming-game_thumbnail
	[game]="game"
	[error]="error"
	[fixedWidth]="fixedWidth"
	[options]="defaultedOptions"
	[gameTagText]="'game-thumb.tags.' + gameTag | translate"
	[gameTag]="gameTag"
	[jackpotValue]="jackpotValue"
	[authenticated]="authenticated"
	[playForFunEnabled]="playForFunEnabled"
	[isNavigateToGamePageEnabled]="isNavigateToGamePageEnabled"
	[errorText]="showErrorText ? (error | translate) : ''"
	[ariaLabels]="translatedAriaLabels$ | async"
	[imageVariant]="thumbnailVariant"
	[imageSize]="thumbnailSize"
	[styleOptions]="styleOptions"
	[urls]="urls"
	[showTitle]="!hideTitle"
	[isCensored]="isCensored"
	[matTooltip]="(showTooltip ? game?.name : undefined)"
	(thumbnailClicked)="onThumbnailClicked($event)"
	[matTooltipClass]="tooltipClass"
	[showSubtitle]="showSubtitle"
	(gameNameClicked)="onThumbnailClicked($event)"
>
	<gaming-game_overlay
		*ngIf="showThumbnailHover"
		slot="overlay"
		data-test-id="game-overlay"
		[fixedWidth]="fixedWidth"
		[authenticated]="authenticated"
		[gameError]="error"
		[errorText]="showErrorText ? (error | translate) : ''"
		[interactionMode]="interactionMode"
		[interactionModeIcon]="interactionModeIcon"
		[isFavorited]="favorite"
		[withGameTag]="hasGameTag"
		[game]="game"
		[urls]="urls"
		[showFavoriteIcon]="showFavoriteIcon"
		[ariaLabels]="translatedAriaLabels$ | async"
		[playForFunEnabled]="playForFunEnabled"
		[loginToPlayText]="'game-launcher.login-to-play' | translate"
		[playForRealText]="'game-launcher.play-for-real' | translate"
		[playForFunText]="(playForFunEnabled ? 'game-launcher.play-for-fun' : null) | translate"
		[customActionText]="customActionText | translate"
		[gameSelectedText]="'game-thumb.text-game-selected' | translate"
		[addGameText]="'game-launcher.add-game' | translate"
		[isPlayForRealTextButtonEnabled]="isPlayForRealTextButtonEnabled"
		[isNavigateToGamePageEnabled]="isNavigateToGamePageEnabled"
		[alternateMultiGameWindowLink]="alternateMultiGameWindowLink"
		[multiGameWindowMode]="multiGameWindowMode"
		[playForRealText]="'game-launcher.play-for-real' | translate"
		[overlayVariant]="thumbnailVariant"
		[overlaySize]="thumbnailSize"
		(selectGame)="onSelectGame()"
		(overlayClick)="onThumbnailClicked($event)"
		(toggleFavorite)="toggleFavorite()"
	></gaming-game_overlay>
</gaming-game_thumbnail>
